<template>
  <el-dialog
    title="修改展示终端"
    :visible.sync="dialogInfo.show"
    @close="closeDialog"
    :close-on-click-modal="false"
    destroy-on-close
    width="45%"
  >
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="130px"
      ref="videoForm"
    >
      <el-row>
        <el-form-item class="scale" label="APP是否展示：" required>
          <el-radio-group v-model="isApp">
            <el-radio
              v-for="item in selectKeys"
              :key="item.paramKey"
              :label="item.paramKey"
              >{{ item.paramValue }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item class="scale" label="WEB是否展示：" required>
          <el-radio-group v-model="isWeb">
            <el-radio
              v-for="item in selectKeys"
              :key="item.paramKey"
              :label="item.paramKey"
              >{{ item.paramValue }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item class="scale" label="小程序是否展示：" required>
          <el-radio-group v-model="isApplet">
            <el-radio
              v-for="item in selectKeys"
              :key="item.paramKey"
              :label="item.paramKey"
              >{{ item.paramValue }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item class="scale" label="PC端是否展示：" required>
          <el-radio-group v-model="isPc">
            <el-radio
              v-for="item in selectKeys"
              :key="item.paramKey"
              :label="item.paramKey"
              >{{ item.paramValue }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="closeDialog" title="取消"></butn>
      <butn btntype="primary" @click="doChange" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";

export default {
  components: { butn },
  props: {
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    api: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      selectKeys: [
        { paramKey: 0, paramValue: "否" },
        { paramKey: 1, paramValue: "是" },
      ],
      isApp: 0,
      isWeb: 0,
      isApplet: 0,
      isPc: 0,
    };
  },
  created() {
    const { isApp = 0, isWeb = 0, isPc = 0, isApplet = 0 } = this.dialogInfo;
    this.isApp = isApp;
    this.isWeb = isWeb;
    this.isApplet = isApplet;
    this.isPc = isPc;
  },
  methods: {
    doChange() {
      this.api({
        uuid: this.dialogInfo.uuid,
        isApp: this.isApp,
        isPc: this.isPc,
        isWeb: this.isWeb,
        isApplet: this.isApplet,
      }).then(({ code, msg }) => {
        if (code !== 0) return;
        this.$message.success(msg);
        this.$emit("close", true);
      });
    },
    closeDialog() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-item {
  display: flex;
  line-height: 30px;
}
.detail-item-left {
  width: 100px;
  text-align: right;
}
.detail-item-right {
  width: calc(100% - 120px);
}
.gray-char {
  color: #b4b4b4;
}
</style>
